/*=========================================================================================
  File Name: moduleEmailActions.js
  Description: Email Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getSpareparts({ commit }, status) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/technical/sparepart/?status=${status}`)
        .then((response) => {
          commit("SET_ITEMS", response.data.values);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  showSparepart({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/technical/sparepart/${id}`)
        .then((resp) => {
          commit("SET_ITEM", resp.data.values);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  storeSparepart({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let endpoint = `/technical/sparepart?status=${payload.status}`;

      axios
        .post(endpoint, payload.body)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateSparepart({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `/technical/sparepart/${payload.id}?status=${payload.status}`,
          payload.body
        )
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  uploadImage({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/technical/sparepart/${payload.id}/upload?status=${payload.status}`,
          payload.body
        )
        .then((resp) => {
          resolve(resp);
        });
    }).catch((err) => {
      reject(err);
    });
  },
  deleteSparepart({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/technical/sparepart/${payload.id}?status=${payload.status}`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
